import React from 'react';
import TextIMG from '../../../assets/file.png';
import { MenuItem } from "@mui/material";
import { saveAs } from 'file-saver';

const TextDownloadButton: React.FC<{ content: any }> = ({ content }) => {
    const downloadAsText = (content: string, filename: string) => {
        // Apply content transformations
        const formattedContent = content
        .replace(/\*{2}([^\*]+)\*{2}/g, '$1') // Remove double asterisks used to denote headings
        .replace(/\*([^*]+)\*/g, '$1') // Remove single asterisks
        .replace(/(\.\s+)/g, '.\n') // Add a newline after each full stop
        .replace(/\n\s+/g, '\n'); // Remove leading whitespace after newlines

        // Create blob and save as text file
        const blob = new Blob([formattedContent], { type: 'text/plain' });
        saveAs(blob, filename);
    };


    const handleDownload = () => {
        downloadAsText(content, 'document.txt');
    };

    const iconStyle = {
        width: '20px',
        height: '20px',
        marginRight: '10px',
        fontSize: '14px'
    };

    return (
        <MenuItem onClick={handleDownload} className="msMenuItem">
            <i className="msIcons">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linejoin="round" stroke-width="32" d="M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z"></path><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 56v120a32 32 0 0 0 32 32h120m-232 80h160m-160 80h160"></path></svg>
            </i>
            {/* <img src={TextIMG} alt="Text" className="msIcons" /> */}
            <span className='msIcons'>Text</span>
        </MenuItem>
    );
};

export default TextDownloadButton;
